import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CardComponent } from './components/card/card.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { TabsStepperComponent } from './components/tabs-stepper/tabs-stepper.component';
import { OperationFinishedModalComponent } from './modals/operation-finished-modal/operation-finished-modal.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { ProfileImageMyDataComponent } from './components/profile-image-my-data/profile-image-my-data.component';
import { PasswordRestoredModalComponent } from './modals/password-restored-modal/password-restored-modal.component';
import { PerformanceChartComponent } from './components/performance-chart/performance-chart.component';
import { TrendChartComponent } from './components/trend-chart/trend-chart.component';
import { GenerateCreditNoteConfirmationComponent } from './modals/generate-credit-note-confirmation/generate-credit-note-confirmation.component';
import { DetailsNoteCreditTransacctionComponent } from './modals/details-note-credit-transacction/details-note-credit-transacction.component';
import { DetailsTransactionComponent } from './modals/details-transaction/details-transaction.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgChartsModule } from 'ng2-charts';
import { DataTablesModule } from 'angular-datatables';
import { AmountFormaterDirective } from './directives/amount-formater.directive';
import { RutFormatterPipe } from './pipes/rut-formatter.pipe';
import { RutFormatterDirective } from './directives/rut-formatter.directive';
import { NavigationService } from '../services/navigation.service';
import { RutFormatterV2Directive } from './directives/rut-formatter-v2.directive';
import { PhoneFormatterDirective } from './directives/phone-formatter.directive';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { TermsConditionModalComponent } from './modals/terms-condition-modal/terms-condition-modal.component';
import { ConfirmationModalComponent } from './modals/confirmation-modal/confirmation-modal.component';
import { DndDirective } from './directives/dnd.directive';
import { CreationMassiveErrorModalComponent } from './modals/creation-massive-error-modal/creation-massive-error-modal.component';
import { TitleCasePipe } from './pipes/title-case.pipe';
import { MassiveErrorGenericModalComponent } from './modals/massive-error-generic-modal/massive-error-generic-modal.component';
import { SubNavbarComponent } from './components/sub-navbar/sub-navbar.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ConfirmPayOrderComponent } from './components/confirm-pay-order/confirm-pay-order.component';
import { AramarkTableComponent } from './components/aramark-table/aramark-table.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { SidebarItemComponent } from './components/sidebar-item/sidebar-item.component';
import { OperationSuccessModalComponent } from './modals/operation-success-modal/operation-success-modal.component';
import { CleanDescriptionPipe } from './pipes/cleanDescription.pipe';
@NgModule({
  declarations: [
    CardComponent,
    SidebarComponent,
    NavbarComponent,
    TabsStepperComponent,
    OperationFinishedModalComponent,
    PaginatorComponent,
    PasswordRestoredModalComponent,
    ProfileImageMyDataComponent,
    PerformanceChartComponent,
    TrendChartComponent,
    GenerateCreditNoteConfirmationComponent,
    DetailsNoteCreditTransacctionComponent,
    DetailsTransactionComponent,
    AmountFormaterDirective,
    RutFormatterPipe,
    RutFormatterDirective,
    RutFormatterV2Directive,
    PhoneFormatterDirective,
    LoadingSpinnerComponent,
    TermsConditionModalComponent,
    ConfirmationModalComponent,
    DndDirective,
    CreationMassiveErrorModalComponent,
    TitleCasePipe,
    MassiveErrorGenericModalComponent,
    SubNavbarComponent,
    ConfirmPayOrderComponent,
    AramarkTableComponent,
    OnlyNumbersDirective,
    OperationSuccessModalComponent,
    CleanDescriptionPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPermissionsModule.forChild(),
    NgChartsModule,
    DataTablesModule,
    FormsModule,
    TypeaheadModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circleSwish,
      backdropBackgroundColour: 'rgba(0,0,0,0.6)',
      backdropBorderRadius: '',
      primaryColour: '#FFFFFF',
      secondaryColour: '#FF0100',
      tertiaryColour: '#FF0100',
    }),
    PaginationModule.forRoot(),
  ],
  exports: [
    CardComponent,
    SidebarComponent,
    NavbarComponent,
    SubNavbarComponent,
    TabsStepperComponent,
    PaginatorComponent,
    ProfileImageMyDataComponent,
    PasswordRestoredModalComponent,
    PerformanceChartComponent,
    TrendChartComponent,
    GenerateCreditNoteConfirmationComponent,
    DetailsNoteCreditTransacctionComponent,
    ReactiveFormsModule,
    NgxPermissionsModule,
    AmountFormaterDirective,
    RutFormatterPipe,
    RutFormatterDirective,
    RutFormatterV2Directive,
    PhoneFormatterDirective,
    LoadingSpinnerComponent,
    TitleCasePipe,
    AramarkTableComponent,
    OnlyNumbersDirective,
    CleanDescriptionPipe,
  ],
})
export class SharedModule {}
